/**
 * T2 — 業務データ（人名・会社名・品名・書類名など）の表示。
 *
 * `data-no-translate` を付けるので、英語表示でもこの値はモデルに送られず、
 * 別人の名前や別の会社名に化けることが原理的に起きない。
 * 英語表記（name_en）が登録されているときだけ、英語表示で2行目に出す。
 */
import { useT } from '@/i18n/LanguageContext';

export const Biz = ({ children, className, as: As = 'span', ...rest }) => (
  <As data-no-translate className={className} {...rest}>{children}</As>
);

export const BizName = ({ ja, en, className, subClassName = 'block text-[11px] font-normal text-zinc-500', testid }) => {
  const { lang } = useT();
  const sub = lang === 'en' && (en || '').trim() && (en || '').trim() !== (ja || '').trim();
  return (
    <span data-no-translate={sub ? 'strict' : true} className={className} data-testid={testid}>
      {ja}
      {sub ? <span className={subClassName} data-testid={testid ? `${testid}-en` : undefined}>{en}</span> : null}
    </span>
  );
};

export default BizName;
